import React from 'react'
import styles from './UserDepartmentsTable.module.scss'
import { t } from 'ttag'

import noDepartments from 'images/illustrations/no-departments.svg'
import { ADMIN_ROLE } from 'constants/users'

export const NoDepartments = ({ selectedUser }) => {
  const userName = `${selectedUser?.first_name} ${selectedUser?.last_name}`

  return (
    <div className={styles.noDepartments}>
      <div className={styles.noDepartmentsImage}>
        <img src={noDepartments} alt="no departments" />
      </div>
      {selectedUser.role === ADMIN_ROLE ? (
        <div className={styles.noDepartmentsLabel}>
          {t`Like every admin, ${userName} has access to all departments and jobs.`}
          {` `}
          {t`Added departments and jobs will affect their permissions only if they stop being an administrator.`}
          <br />
          <br />
          {t`Use`} <span className={styles.highlight}>{t`Add Department`}</span>{' '}
          {t`select above to grant access to departments.`}
        </div>
      ) : (
        <div className={styles.noDepartmentsLabel}>
          {userName} {t`has no access to any departments or jobs yet`}. <br />
          {t`Use`} <span className={styles.highlight}>{t`Add Department`}</span>{' '}
          {t`select above to grant access to departments.`}
        </div>
      )}
    </div>
  )
}
